import { useContext, useState } from 'react';

import { Button, Typography } from 'design_system/src';

import {
	validationItem,
	validationItemState,
} from 'components/hocs/messages/messages';
import { VehiclePopulated } from 'models/inventory/interfaces/vehicle.interface';
import EditVehicle from 'views/inventory/edit/EditVehicle';
import { ozonerContext } from '../../OzonerContext';

export function useVehicleDataCompleteness(vehicle?: VehiclePopulated) {
	const hasVehicleLocation = !!vehicle?.location?.hub;
	const hasVehicleMileage =
		vehicle?.mileage !== undefined && vehicle?.mileage !== null;
	const hasVehicleBrakeType = !!vehicle?.brakeType;
	const hasVehicleSN = !!vehicle?.vehicleSN;
	const hasVehiclePurchaseDate = !!vehicle?.purchaseDate;
	const hasVehicleDataComplete =
		!!vehicle &&
		hasVehicleLocation &&
		hasVehicleMileage &&
		hasVehicleBrakeType &&
		hasVehicleSN &&
		hasVehiclePurchaseDate;

	return {
		hasVehicleLocation,
		hasVehicleMileage,
		hasVehicleBrakeType,
		hasVehicleSN,
		hasVehiclePurchaseDate,
		hasVehicleDataComplete,
	};
}

export function VehicleDataValidation() {
	const { vehicle, initializeContext } = useContext(ozonerContext);
	const [openEditVehicle, setOpenEditVehicle] = useState(false);

	const {
		hasVehicleLocation,
		hasVehicleMileage,
		hasVehicleBrakeType,
		hasVehicleSN,
		hasVehiclePurchaseDate,
		hasVehicleDataComplete,
	} = useVehicleDataCompleteness(vehicle);

	if (!vehicle) return null;

	return (
		<>
			<div
				id="validate-soli-ozoner"
				className="p_md border_b_solid border_1 border_neutral_400 display_flex flex_col flex_gap_md"
			>
				<Typography scale="medium" weight="600" textColor="neutral_900">
					Datos del vehículo
				</Typography>
				<div className="display_flex flex_gap_xs flex_align_center">
					{validationItem(
						hasVehicleLocation
							? validationItemState.valid
							: validationItemState.invalid,
						{
							[validationItemState.valid]: 'Ubicación asignada',
							[validationItemState.invalid]: 'Ubicación sin asignar',
						},
					)}
				</div>
				<div className="display_flex flex_gap_xs flex_align_center">
					{validationItem(
						hasVehicleMileage
							? validationItemState.valid
							: validationItemState.invalid,
						{
							[validationItemState.valid]: 'Kilometraje registrado',
							[validationItemState.invalid]: 'Kilometraje sin registrar',
						},
					)}
				</div>
				<div className="display_flex flex_gap_xs flex_align_center">
					{validationItem(
						hasVehicleBrakeType
							? validationItemState.valid
							: validationItemState.invalid,
						{
							[validationItemState.valid]: 'Tipo de freno asignado',
							[validationItemState.invalid]: 'Tipo de freno sin asignar',
						},
					)}
				</div>
				<div className="display_flex flex_gap_xs flex_align_center">
					{validationItem(
						hasVehicleSN
							? validationItemState.valid
							: validationItemState.invalid,
						{
							[validationItemState.valid]: 'Número de serie registrado',
							[validationItemState.invalid]: 'Número de serie sin registrar',
						},
					)}
				</div>
				<div className="display_flex flex_gap_xs flex_align_center">
					{validationItem(
						hasVehiclePurchaseDate
							? validationItemState.valid
							: validationItemState.invalid,
						{
							[validationItemState.valid]: 'Fecha de compra registrada',
							[validationItemState.invalid]: 'Fecha de compra sin registrar',
						},
					)}
				</div>
				{!hasVehicleDataComplete && (
					<Button
						scale="small"
						color="grey"
						onClick={() => setOpenEditVehicle(true)}
					>
						Completar datos de la moto
					</Button>
				)}
			</div>

			<EditVehicle
				open={openEditVehicle}
				setOpen={setOpenEditVehicle}
				values={vehicle}
				setResult={() => {
					setOpenEditVehicle(false);
					initializeContext();
				}}
			/>
		</>
	);
}
